import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/256px-Flag_DK.png'
import _imports_1 from '../../assets/256px-Flag_UK.png'
import _imports_2 from '@/assets/mitid_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-2626ae4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "header d-print-none" }
const _hoisted_7 = { class: "portal-header" }
const _hoisted_8 = { class: "container portal-header-inner px-0" }
const _hoisted_9 = { class: "logo__name h1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-print-block" }, "start", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "start", -1))
const _hoisted_12 = { class: "portal-info" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "on-behalf-of"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
], -1))
const _hoisted_16 = { class: "on-behalf-of-body" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "user text-color-white"
}
const _hoisted_19 = { class: "weight-semibold" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "text-color-white" }
const _hoisted_22 = {
  key: 1,
  class: "user text-color-white"
}
const _hoisted_23 = {
  style: {"stroke-width":"1","stroke":"white","fill":"white"},
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#folder-multiple" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "user text-color-white"
}
const _hoisted_27 = {
  style: {"stroke-width":"1","stroke":"white","fill":"white"},
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#people-alt" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = {
  key: 4,
  class: "row.no-gutters mt-4"
}
const _hoisted_33 = {
  class: "language-switcher",
  style: {"background-color":"#078856"}
}
const _hoisted_34 = { class: "container" }
const _hoisted_35 = { "aria-label": "Vælg sprog ved klik af flag ikon" }
const _hoisted_36 = ["aria-label"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Danish Flag",
  height: "24",
  width: "40"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["aria-label"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "English Flag",
  height: "24",
  width: "40"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 0,
  class: "navbar navbar-primary text-color-white"
}
const _hoisted_43 = { class: "navbar-inner container px-0" }
const _hoisted_44 = { class: "nav-primary" }
const _hoisted_45 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "modal-title" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "modal-footer" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))
const _hoisted_54 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_55 = {
  class: "modal-content",
  style: {"max-width":"1000px"}
}
const _hoisted_56 = { class: "modal-header" }
const _hoisted_57 = { class: "modal-title" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = { class: "col-4" }
const _hoisted_62 = { class: "form-group-radio" }
const _hoisted_63 = ["id", "data-cy-id"]
const _hoisted_64 = ["for"]
const _hoisted_65 = { class: "col-4" }
const _hoisted_66 = { class: "col-4" }
const _hoisted_67 = ["href"]
const _hoisted_68 = { class: "modal-footer" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))
const _hoisted_70 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = { class: "modal-title" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "modal-body" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "MitID login",
  class: "icon"
}, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = { class: "modal-title" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_simple_text = _resolveComponent("simple-text")!
  const _component_MultipleToast = _resolveComponent("MultipleToast")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isTestFramework)
      ? (_openBlock(), _createBlock(_component_Toast, {
          key: 0,
          header: this.sessionExpirationTitle,
          message: this.sessionExpirationText,
          show: _ctx.showExpirationNotification,
          showCloseButton: _ctx.showCloseButtonToast1,
          type: 'info',
          name: "fromCompTheHeaderToast1"
        }, {
          footer: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("p", null, [
              _createVNode(_component_SimpleText, { "text-key": "shared.your.session.expires.at" }),
              _createElementVNode("strong", null, _toDisplayString(_ctx.sessionExpirationTime), 1)
            ]),
            _hoisted_2,
            _createElementVNode("button", {
              id: "login-refresh-button",
              class: "button button-secondary d-print-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshLogin()))
            }, [
              _createVNode(_component_SimpleText, { "text-key": "sharedContent.refreshSessionButtonText" })
            ]),
            _createElementVNode("button", {
              id: "logout-notification-button",
              class: "button button-secondary d-print-none",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
            }, [
              _createVNode(_component_SimpleText, { "text-key": "sharedContent.logout" })
            ])
          ]),
          _: 1
        }, 8, ["header", "message", "show", "showCloseButton"]))
      : _createCommentVNode("", true),
    (_ctx.getContactPerson.messages)
      ? (_openBlock(), _createBlock(_component_Toast, {
          key: 1,
          header: this.popupMessageTitle,
          message: this.popupMessageText,
          show: _ctx.getContactPerson.messages,
          showCloseButton: _ctx.showCloseButtonToast2,
          type: 'info',
          name: "fromCompTheHeaderToast2",
          onToastOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearMessages()))
        }, {
          footer: _withCtx(() => [
            _hoisted_3,
            (_ctx.getContactPerson.messages != 'sharedContent.popupMessageText')
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.getContactPerson.messages), 1))
              : _createCommentVNode("", true),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["header", "message", "show", "showCloseButton"]))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "logo",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getContentfulString('application.main-title')), 1),
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.thirdpartyInfo.behalfOfVatNr)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
                          [_directive_dompurify_html, _ctx.behalfOfText]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_ctx.getCurrentUser.profile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getCurrentUser.profile.name), 1),
                        _hoisted_20,
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getCurrentUser.profile['dk:gov:org_name'] || ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.thirdpartyInfo.behalfOfVatNr)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                        _createElementVNode("a", {
                          style: {"cursor":"pointer"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmEndAction()))
                        }, [
                          _createElementVNode("u", null, _toDisplayString(this.getContentfulString('thirdparty.has-access-to.terminate-accesss.button')), 1),
                          _createTextVNode("  ")
                        ]),
                        (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.thirdpartyInfo.behalfOfVatNr && this.determineLegitimateAccesses(_ctx.givenAccessInfos))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _createElementVNode("a", {
                          "data-cy-id": "anchor_change_access",
                          style: {"cursor":"pointer"},
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.initChangeAccess()))
                        }, [
                          _createElementVNode("u", null, _toDisplayString(this.getContentfulString('thirdparty.has-access-to.change-access.button')), 1),
                          _createTextVNode("  ")
                        ]),
                        (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_29))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!this.basisModule)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (!_ctx.isAuthenticated && _ctx.showSSILogin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        id: "login-button",
                        class: "button button-secondary d-print-none",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loginPopup()))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.login" })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isAuthenticated && !_ctx.showSSILogin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        id: "login-button",
                        class: "button button-secondary d-print-none",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.login()))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.login" })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        id: "logout",
                        class: "button button-secondary d-print-none",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.logout()))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.logout" })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (!_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "button button-secondary d-print-none",
                        to: "/",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetBasisModule()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SimpleText, { "text-key": "header.button.go-to-home" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])),
            (_ctx.languageSelectEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("ul", _hoisted_35, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "?lang=da",
                            lang: "da",
                            class: _normalizeClass({'selected': _ctx.currentLocale === 'da'}),
                            "aria-label": _ctx.currentLocale === 'da' ? 'Valgt sprog: Dansk' : 'Vælg sprog: Dansk',
                            onClick: _cache[9] || (_cache[9] = _withModifiers(async ()=> await _ctx.setLocale('da'), ["prevent"]))
                          }, _hoisted_38, 10, _hoisted_36)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "?lang=en-US",
                            lang: "en-US",
                            class: _normalizeClass({'selected': _ctx.currentLocale === 'en-US' && !_ctx.useTextKeys }),
                            "aria-label": _ctx.currentLocale === 'en-US' && !_ctx.useTextKeys ? 'Selected language: English' : 'Select language: English',
                            onClick: _cache[10] || (_cache[10] = _withModifiers(async ()=> await _ctx.setLocale('en-US'), ["prevent"]))
                          }, _hoisted_41, 10, _hoisted_39)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.showNavigation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("ul", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuLive.menuItems, (menuItem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: menuItem.label
                  }, [
                    (_ctx.isPrivateUser ? menuItem.showToPrivateUser : true)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          id: `${menuItem.id}-link`,
                          exact: menuItem.exact,
                          to: menuItem.link,
                          "active-class": "current",
                          class: "nav-link",
                          onClick: ($event: any) => (menuItem.link === '/calculator' ? _ctx.newCalculation() : ''),
                          "data-cy-inner": menuItem.labelKey,
                          tabindex: "0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(menuItem.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["id", "exact", "to", "onClick", "data-cy-inner"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModalDialog)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h2", _hoisted_48, [
                  _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.endActionText" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelEndAction()))
                }, _hoisted_50)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("p", null, _toDisplayString(_ctx.endActionText), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_router_link, {
                  class: "button button-primary",
                  "data-cy-id": "modal-confirm",
                  to: "/",
                  onClick: _ctx.endAction
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.endActionText" })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  "data-cy-id": "modal-cancel",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancelEndAction()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.cancelButton" })
                ])
              ])
            ])
          ]),
          _hoisted_53
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showChangeAccessModal)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("h2", _hoisted_57, [
                  _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.change-access.button" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelChangeAccess()))
                }, _hoisted_59)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("h3", null, [
                  _createVNode(_component_simple_text, { "text-key": "menu.setupmenu.item.showaccess" })
                ]),
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_dompurify_html, _ctx.documentToHtmlString(_ctx.changeAccessModalDescription)]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessInfos.filter(x => ((x.expireDate > _ctx.currentDate && !x.revoked && x.vatId != _ctx.thirdpartyInfo.behalfOfVatNr) || (!x.expireDate && !x.revoked && x.vatId != _ctx.thirdpartyInfo.behalfOfVatNr)) && (x.individualsAccessInfoList && x.individualsAccessInfoList.some(individual => individual.status?.toString()=== "ACCESS_GRANTED"))), (access) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row change-access-item",
                    key: access.id
                  }, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("fieldset", null, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("input", {
                            type: "radio",
                            id: 'radiogroup-access-' + access.id,
                            "data-cy-id": access.vatIdSource,
                            name: "access-group",
                            class: "form-radio radio-large",
                            value: "false"
                          }, null, 8, _hoisted_63),
                          _createElementVNode("label", {
                            class: "form-label",
                            for: 'radiogroup-access-' + access.id
                          }, _toDisplayString(access.privateSource ? _ctx.privateUserText : access.companyNameSource), 9, _hoisted_64)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.labelCvr" }),
                        _createTextVNode(": " + _toDisplayString(access.privateSource ? _ctx.cvrIsPrivateText : access.vatId), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(access.contantPersonName) + ", ", 1),
                        _createElementVNode("a", {
                          href: 'mailto:' + access.contactPersonEmail
                        }, _toDisplayString(access.contactPersonEmail), 9, _hoisted_67)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_router_link, {
                  class: "button button-primary",
                  "data-cy-id": "modal-confirm",
                  to: "/overview",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeAccess()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.change-access.button" })
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  "data-cy-id": "modal-cancel",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cancelChangeAccess()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "thirdparty.has-access-to.cancelButton" })
                ])
              ])
            ])
          ]),
          _hoisted_69
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.loginPressed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("h2", _hoisted_73, [
                  _createVNode(_component_SimpleText, { "text-key": "login.popup.title" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeLoginDialog()))
                }, _hoisted_75)
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  "data-cy-id": "modal-login",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loginNormal())),
                  class: "svg-button"
                }, [
                  _hoisted_77,
                  _createVNode(_component_SimpleText, { "text-key": "login.popup.button.normal.title" })
                ]),
                _hoisted_78,
                _hoisted_79,
                _createVNode(_component_SimpleText, { "text-key": "login.popup.description" }),
                _hoisted_80,
                _hoisted_81,
                _createElementVNode("h3", _hoisted_82, [
                  _createVNode(_component_SimpleText, { "text-key": "login.popup.ssi.title" })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_SimpleText, { "text-key": "login.popup.ssi.description" })
                ]),
                _createElementVNode("button", {
                  class: "link-button",
                  "data-cy-id": "modal-login-ssi",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loginSSI()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "login.popup.button.ssi.title" })
                ])
              ])
            ])
          ]),
          _hoisted_83
        ], 64))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_MultipleToast, {
      identifier: "news-toast",
      ref: "newsToast",
      onMultipleToastClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setShown($event)))
    }, null, 512), [
      [_vShow, _ctx.isAuthenticated && _ctx.showNewsOnPage()]
    ])
  ], 64))
}